import { render, staticRenderFns } from "./NirvarLimitForm.vue?vue&type=template&id=13b12fe1&scoped=true&"
import script from "./NirvarLimitForm.vue?vue&type=script&lang=js&"
export * from "./NirvarLimitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b12fe1",
  null
  
)

export default component.exports